// extracted by mini-css-extract-plugin
export default {"section":"heading_section__hThSG"};